import * as React from 'react';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	averageRating: number;
	votes: number;
}

const ReviewScore = (props: IProps) => {
	const { averageRating, votes } = props;

	return (
		<div className="review-score d-flex flex-row align-items-center">
			{renderIcon('star1', 20, 20)}
			<h3>{averageRating.toFixed(1)}</h3>
			<h3>{`(${votes})`}</h3>
		</div>
	);
};

export default ReviewScore;
